import { Box, Container, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import threedot from '../../assets/images/threeline.svg';
import { setTopTab, toggleLoginScreen } from '../../reducers/UiReducer';
import { useNavigate } from 'react-router-dom';

const Header = () => {
	const dispatch = useDispatch();
	const theme = useTheme();
	const navigate = useNavigate();
	const { topTab } = useSelector((state) => state.ui);
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	return (
		<Box display={'flex'} justifyContent={'space-around'} className='container'>
			<Box display={'flex'} justifyContent={matches ? 'space-between' : ''}>
				<img
					onClick={() => navigate('/')}
					src='https://www.musafirbazar.com/static/media/mb.ff1a1c86dd49c134632a.jpeg'
					style={{ width: 45, height: 45, cursor: 'pointer' }}
				/>
				{matches ? (
					<img src={threedot} style={{ width: 45, height: 45 }} />
				) : (
					<>
						<span style={{ marginRight: 35 }}></span>
						<Box
							onClick={() => dispatch(setTopTab('flight'))}
							style={{ display: 'flex', alignItems: 'center' }}
							sx={{
								color: topTab === 'flight' ? 'orange' : '',
								'&:hover': {
									color: 'orange',
									cursor: 'pointer',
								},
							}}>
							<img
								src='https://www.ixigo.com/rt-udaan/pc/img/flight-new.svg'
								className='img'
							/>
							<span>Flight</span>
						</Box>
						<Box
							onClick={() => dispatch(setTopTab('bus'))}
							style={{ display: 'flex', alignItems: 'center', marginLeft: 20 }}
							sx={{
								color: topTab === 'bus' ? 'orange' : '',
								'&:hover': {
									color: 'orange',
									cursor: 'pointer',
								},
							}}>
							<img src='https://www.ixigo.com/rt-udaan/pc/img/bus-new.svg' />
							<span>Buses</span>
						</Box>
						<Box
							onClick={() => dispatch(setTopTab('hotel'))}
							style={{ display: 'flex', alignItems: 'center', marginLeft: 20 }}
							sx={{
								color: topTab === 'hotel' ? 'orange' : '',
								'&:hover': {
									color: 'orange',
									cursor: 'pointer',
								},
							}}>
							<img src='https://www.ixigo.com/rt-udaan/pc/img/hotel-new.svg' />
							<span>Hotels</span>
						</Box>
						<Box
							onClick={() => dispatch(setTopTab('holiday'))}
							style={{ display: 'flex', alignItems: 'center', marginLeft: 20 }}
							sx={{
								'&:hover': {
									color: topTab === 'holiday' ? 'orange' : '',
									cursor: 'pointer',
								},
							}}>
							<img
								src='https://www.ixigo.com/rt-udaan/pc/img/packages.svg'
								style={{ height: 30 }}
							/>
							<span>Holidays</span>
						</Box>
						<Box
							onClick={() => dispatch(setTopTab('promo'))}
							style={{ display: 'flex', alignItems: 'center', marginLeft: 20 }}
							sx={{
								color: topTab === 'promo' ? 'orange' : '',
								'&:hover': {
									color: 'orange',
									cursor: 'pointer',
								},
							}}>
							<img
								src='https://www.ixigo.com/rt-udaan/pc/img/flight-new.svg'
								className='img'
							/>
							<span>Promo Fare</span>
						</Box>
					</>
				)}
			</Box>
			{matches ? (
				''
			) : (
				<Box display={'flex'} justifyContent={'space-between'}>
					<Box
						ml={'20px'}
						style={{ display: 'flex', alignItems: 'center' }}
						sx={{
							'&:hover': {
								color: 'orange',
								cursor: 'pointer',
							},
						}}>
						<img src='https://www.ixigo.com/rt-udaan/pc/img/customer-new.svg' />
						<span>Customer Service</span>
					</Box>
					<Box
						ml={'20px'}
						style={{ display: 'flex', alignItems: 'center' }}
						sx={{
							'&:hover': {
								color: 'orange',
								cursor: 'pointer',
							},
						}}>
						<img src='https://www.ixigo.com/rt-udaan/pc/img/user-new.svg' />
						<span>Offers</span>
					</Box>

					<Box
						onClick={() => dispatch(toggleLoginScreen(true))}
						ml={'20px'}
						style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
						sx={{
							'&:hover': {
								color: 'orange',
								cursor: 'pointer',
							},
						}}>
						<img src='https://www.ixigo.com/rt-udaan/pc/img/user-new.svg' />
						<span>Login/Signup</span>
					</Box>
				</Box>
			)}
		</Box>
	);
};

export default Header;
